import Breadcrumbs, { BreadcrumbsProps } from './Breadcrumbs';

export type { BreadcrumbsProps };
export default Breadcrumbs;

export type { Crumb } from './Breadcrumbs';
